<!-- VoiceProfileSelector.vue -->
<template>
  <div class="voice-profile-wrapper">
    <div class="voice-profile-control">
      <div class="control-group">
        <select
          v-model="selectedProfile"
          @change="onProfileChange(selectedProfile)"
          class="profile-select"
        >
          <option value="US English">🧭 English 1</option>
          <option value="UK English">🧭 English 2</option>
          <option value="Spanglish">🧭 Spanglish</option>
        </select>
      </div>
    </div>
  </div>
</template>


<script>
import { voiceProfiles, defaultProfile } from './mixins/voiceProfiles';

export default {
  name: 'VoiceProfileSelector',
  data() {
    return {
      selectedProfile: defaultProfile
    };
  },
  methods: {
    onProfileChange(profileName) {
      // First emit profile change
      this.$emit('profile-changed', profileName);
      // Then emit cache clear event
      this.$emit('profile-changed-clear-cache');
    }
  },
};
</script>

<style scoped>
.voice-profile-wrapper {
  display: flex;
  justify-content: center;
  width: 100%;
  padding: 10px 0;
}

.voice-profile-control {
  display: inline-flex;
  align-items: center;
}

.profile-select {
  border: 1px solid #4299e1;
  border-radius: 4px;
  padding: 4px 24px 4px 8px;
  font-size: 0.9em;
  cursor: pointer;
}

.theme--dark .profile-select {
  background: #2d3748;
  border: 1px solid #4a5568;
  color: #cbd5e0;
}

.profile-select:hover {
  background: #3182ce;
}

.profile-select:focus {
  outline: none;
  border-color: #2b6cb0;
}

@media screen and (max-width: 600px) {
  .voice-profile-wrapper {
    padding: 15px 0;
  }
}
</style>
